require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.array.reduce-right.js");
!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t(e.RematchPersist = {});
}(this, function (e) {
  "use strict";

  var _t = function t() {
      return (_t = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; n > r; r++) {
          for (var o in t = arguments[r]) {
            Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
          }
        }
        return e;
      }).apply(this, arguments);
    },
    r = "persist:",
    n = "persist/FLUSH",
    o = "persist/REHYDRATE",
    i = "persist/PAUSE",
    u = "persist/PERSIST",
    s = "persist/PURGE",
    a = "persist/REGISTER",
    f = -1,
    c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
    d = Object.assign || function (e) {
      for (var t = 1; arguments.length > t; t++) {
        var r = arguments[t];
        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }
      return e;
    };
  function l(e, t, r, n) {
    var o = d({}, r);
    return e && "object" === (void 0 === e ? "undefined" : c(e)) && Object.keys(e).forEach(function (n) {
      "_persist" !== n && t[n] === r[n] && (o[n] = e[n]);
    }), o;
  }
  function y(e) {
    var t = e.blacklist || null,
      n = e.whitelist || null,
      o = e.transforms || [],
      i = e.throttle || 0,
      u = "" + (void 0 !== e.keyPrefix ? e.keyPrefix : r) + e.key,
      s = e.storage,
      a = !1 === e.serialize ? function (e) {
        return e;
      } : p,
      f = {},
      c = {},
      d = [],
      l = null,
      y = null;
    function h() {
      if (0 === d.length) return l && clearInterval(l), void (l = null);
      var e = d.shift(),
        t = o.reduce(function (t, r) {
          return r.in(t, e, f);
        }, f[e]);
      if (void 0 !== t) try {
        c[e] = a(t);
      } catch (e) {
        console.error("redux-persist/createPersistoid: error serializing state", e);
      } else delete c[e];
      0 === d.length && (Object.keys(c).forEach(function (e) {
        void 0 === f[e] && delete c[e];
      }), y = s.setItem(u, a(c)).catch(v));
    }
    function v(e) {
      0;
    }
    return {
      update: function update(e) {
        Object.keys(e).forEach(function (r) {
          (function (e) {
            return !(n && -1 === n.indexOf(e) && "_persist" !== e || t && -1 !== t.indexOf(e));
          })(r) && f[r] !== e[r] && -1 === d.indexOf(r) && d.push(r);
        }), Object.keys(f).forEach(function (t) {
          void 0 === e[t] && d.push(t);
        }), null === l && (l = setInterval(h, i)), f = e;
      },
      flush: function flush() {
        for (; 0 !== d.length;) {
          h();
        }
        return y || Promise.resolve();
      }
    };
  }
  function p(e) {
    return JSON.stringify(e);
  }
  function h(e) {
    var t = e.transforms || [],
      n = !1 === e.serialize ? function (e) {
        return e;
      } : v;
    return e.storage.getItem("" + (void 0 !== e.keyPrefix ? e.keyPrefix : r) + e.key).then(function (e) {
      if (e) try {
        var r = {},
          o = n(e);
        return Object.keys(o).forEach(function (e) {
          r[e] = t.reduceRight(function (t, r) {
            return r.out(t, e, o);
          }, n(o[e]));
        }), r;
      } catch (e) {
        throw e;
      }
    });
  }
  function v(e) {
    return JSON.parse(e);
  }
  function b(e) {
    0;
  }
  var m = Object.assign || function (e) {
    for (var t = 1; arguments.length > t; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  };
  var g = 5e3;
  function w(e, t) {
    var a = void 0 !== e.version ? e.version : f,
      c = void 0 === e.stateReconciler ? l : e.stateReconciler,
      d = e.getStoredState || h,
      p = void 0 !== e.timeout ? e.timeout : g,
      v = null,
      w = !1,
      O = !0,
      x = function x(e) {
        return e._persist.rehydrated && v && !O && v.update(e), e;
      };
    return function (f, l) {
      var h = f || {},
        g = h._persist,
        E = function (e, t) {
          var r = {};
          for (var n in e) {
            0 > t.indexOf(n) && Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
          }
          return r;
        }(h, ["_persist"]);
      if (l.type === u) {
        var S = !1,
          j = function j(t, r) {
            S || (l.rehydrate(e.key, t, r), S = !0);
          };
        if (p && setTimeout(function () {
          !S && j(void 0, Error('redux-persist: persist timed out for persist key "' + e.key + '"'));
        }, p), O = !1, v || (v = y(e)), g) return f;
        if ("function" != typeof l.rehydrate || "function" != typeof l.register) throw Error("redux-persist: either rehydrate or register is not a function on the PERSIST action. This can happen if the action is being replayed. This is an unexplored use case, please open an issue and we will figure out a resolution.");
        return l.register(e.key), d(e).then(function (t) {
          (e.migrate || function (e, t) {
            return Promise.resolve(e);
          })(t, a).then(function (e) {
            j(e);
          }, function (e) {
            j(void 0, e);
          });
        }, function (e) {
          j(void 0, e);
        }), m({}, t(E, l), {
          _persist: {
            version: a,
            rehydrated: !1
          }
        });
      }
      if (l.type === s) return w = !0, l.result(function (e) {
        return e.storage.removeItem("" + (void 0 !== e.keyPrefix ? e.keyPrefix : r) + e.key, b);
      }(e)), m({}, t(E, l), {
        _persist: g
      });
      if (l.type === n) return l.result(v && v.flush()), m({}, t(E, l), {
        _persist: g
      });
      if (l.type === i) O = !0;else if (l.type === o) {
        if (w) return m({}, E, {
          _persist: m({}, g, {
            rehydrated: !0
          })
        });
        if (l.key === e.key) {
          var I = t(E, l),
            P = l.payload,
            k = !1 !== c && void 0 !== P ? c(P, f, I, e) : I,
            _ = m({}, k, {
              _persist: m({}, g, {
                rehydrated: !0
              })
            });
          return x(_);
        }
      }
      if (!g) return t(f, l);
      var R = t(E, l);
      return R === E ? f : (R._persist = g, x(R));
    };
  }
  var O = function (e) {
      var t,
        r = e.Symbol;
      return "function" == typeof r ? r.observable ? t = r.observable : (t = r("observable"), r.observable = t) : t = "@@observable", t;
    }("undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof module ? module : Function("return this")()),
    x = {
      INIT: "@@redux/INIT" + Math.random().toString(36).substring(7).split("").join("."),
      REPLACE: "@@redux/REPLACE" + Math.random().toString(36).substring(7).split("").join(".")
    },
    E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
  function S(e, t, r) {
    var n;
    if ("function" == typeof t && void 0 === r && (r = t, t = void 0), void 0 !== r) {
      if ("function" != typeof r) throw Error("Expected the enhancer to be a function.");
      return r(S)(e, t);
    }
    if ("function" != typeof e) throw Error("Expected the reducer to be a function.");
    var o = e,
      i = t,
      u = [],
      s = u,
      a = !1;
    function f() {
      s === u && (s = u.slice());
    }
    function c() {
      if (a) throw Error("You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
      return i;
    }
    function d(e) {
      if ("function" != typeof e) throw Error("Expected the listener to be a function.");
      if (a) throw Error("You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
      var t = !0;
      return f(), s.push(e), function () {
        if (t) {
          if (a) throw Error("You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api-reference/store#subscribe(listener) for more details.");
          t = !1, f();
          var r = s.indexOf(e);
          s.splice(r, 1);
        }
      };
    }
    function l(e) {
      if (!function (e) {
        if ("object" !== (void 0 === e ? "undefined" : E(e)) || null === e) return !1;
        for (var t = e; null !== Object.getPrototypeOf(t);) {
          t = Object.getPrototypeOf(t);
        }
        return Object.getPrototypeOf(e) === t;
      }(e)) throw Error("Actions must be plain objects. Use custom middleware for async actions.");
      if (void 0 === e.type) throw Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
      if (a) throw Error("Reducers may not dispatch actions.");
      try {
        a = !0, i = o(i, e);
      } finally {
        a = !1;
      }
      for (var t = u = s, r = 0; t.length > r; r++) {
        (0, t[r])();
      }
      return e;
    }
    return l({
      type: x.INIT
    }), (n = {
      dispatch: l,
      subscribe: d,
      getState: c,
      replaceReducer: function replaceReducer(e) {
        if ("function" != typeof e) throw Error("Expected the nextReducer to be a function.");
        o = e, l({
          type: x.REPLACE
        });
      }
    })[O] = function () {
      var e,
        t = d;
      return (e = {
        subscribe: function subscribe(e) {
          if ("object" !== (void 0 === e ? "undefined" : E(e)) || null === e) throw new TypeError("Expected the observer to be an object.");
          function r() {
            e.next && e.next(c());
          }
          return r(), {
            unsubscribe: t(r)
          };
        }
      })[O] = function () {
        return this;
      }, e;
    }, n;
  }
  function j(e, t) {
    var r = t && t.type;
    return "Given " + (r && 'action "' + r + '"' || "an action") + ', reducer "' + e + '" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.';
  }
  function I(e) {
    for (var t = Object.keys(e), r = {}, n = 0; t.length > n; n++) {
      var o = t[n];
      "function" == typeof e[o] && (r[o] = e[o]);
    }
    var i = Object.keys(r),
      u = void 0;
    try {
      !function (e) {
        Object.keys(e).forEach(function (t) {
          var r = e[t];
          if (void 0 === r(void 0, {
            type: x.INIT
          })) throw Error('Reducer "' + t + "\" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.");
          if (void 0 === r(void 0, {
            type: "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".")
          })) throw Error('Reducer "' + t + "\" returned undefined when probed with a random type. Don't try to handle " + x.INIT + ' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.');
        });
      }(r);
    } catch (e) {
      u = e;
    }
    return function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = arguments[1];
      if (u) throw u;
      for (var n = !1, o = {}, s = 0; i.length > s; s++) {
        var a = i[s],
          f = e[a],
          c = (0, r[a])(f, t);
        if (void 0 === c) {
          var d = j(a, t);
          throw Error(d);
        }
        o[a] = c, n = n || c !== f;
      }
      return n ? o : e;
    };
  }
  var P = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    },
    k = Object.assign || function (e) {
      for (var t = 1; arguments.length > t; t++) {
        var r = arguments[t];
        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }
      return e;
    };
  function _(e, t, r, n) {
    var o = k({}, r);
    return e && "object" === (void 0 === e ? "undefined" : P(e)) && Object.keys(e).forEach(function (n) {
      var i;
      "_persist" !== n && t[n] === r[n] && (o[n] = null === (i = r[n]) || Array.isArray(i) || "object" !== (void 0 === i ? "undefined" : P(i)) ? e[n] : k({}, o[n], e[n]));
    }), o;
  }
  var R = Object.assign || function (e) {
    for (var t = 1; arguments.length > t; t++) {
      var r = arguments[t];
      for (var n in r) {
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
    }
    return e;
  };
  function T(e) {
    if (Array.isArray(e)) {
      for (var t = 0, r = Array(e.length); e.length > t; t++) {
        r[t] = e[t];
      }
      return r;
    }
    return Array.from(e);
  }
  var A = {
      registry: [],
      bootstrapped: !1
    },
    N = function N() {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : A,
        t = arguments[1];
      switch (t.type) {
        case a:
          return R({}, e, {
            registry: [].concat(T(e.registry), [t.key])
          });
        case o:
          var r = e.registry.indexOf(t.key),
            n = [].concat(T(e.registry));
          return n.splice(r, 1), R({}, e, {
            registry: n,
            bootstrapped: 0 === n.length
          });
        default:
          return e;
      }
    };
  function M(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }
  function C(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }
  var U = C(function (e, t) {
    t.__esModule = !0;
    var r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    function n() {}
    t.default = function (e) {
      var t = e + "Storage";
      return function (e) {
        if ("object" !== ("undefined" == typeof self ? "undefined" : r(self)) || !(e in self)) return !1;
        try {
          var t = self[e],
            n = "redux-persist " + e + " test";
          t.setItem(n, "test"), t.getItem(n), t.removeItem(n);
        } catch (e) {
          return !1;
        }
        return !0;
      }(t) ? self[t] : o;
    };
    var o = {
      getItem: n,
      setItem: n,
      removeItem: n
    };
  });
  M(U);
  var z = C(function (e, t) {
    t.__esModule = !0, t.default = function (e) {
      var t = (0, n.default)(e);
      return {
        getItem: function getItem(e) {
          return new Promise(function (r, n) {
            r(t.getItem(e));
          });
        },
        setItem: function setItem(e, r) {
          return new Promise(function (n, o) {
            n(t.setItem(e, r));
          });
        },
        removeItem: function removeItem(e) {
          return new Promise(function (r, n) {
            r(t.removeItem(e));
          });
        }
      };
    };
    var r,
      n = (r = U) && r.__esModule ? r : {
        default: r
      };
  });
  M(z);
  var L,
    Y = M(C(function (e, t) {
      t.__esModule = !0;
      var r,
        n = (r = z) && r.__esModule ? r : {
          default: r
        };
      t.default = (0, n.default)("local");
    }));
  e.getPersistor = function () {
    return L;
  }, e.default = function (e, r, f) {
    void 0 === e && (e = {});
    var c = _t({
      key: "root",
      storage: Y
    }, e);
    return {
      config: {
        redux: {
          combineReducers: function (e, t) {
            return e.stateReconciler = void 0 === e.stateReconciler ? _ : e.stateReconciler, w(e, I(t));
          }.bind(null, c)
        }
      },
      onStoreCreated: function onStoreCreated(e) {
        L = function (e, t, r) {
          var f = r || !1,
            c = S(N, A, t ? t.enhancer : void 0),
            d = function d(e) {
              c.dispatch({
                type: a,
                key: e
              });
            },
            l = function l(t, r, n) {
              var i = {
                type: o,
                payload: r,
                err: n,
                key: t
              };
              e.dispatch(i), c.dispatch(i), f && y.getState().bootstrapped && (f(), f = !1);
            },
            y = R({}, c, {
              purge: function purge() {
                var t = [];
                return e.dispatch({
                  type: s,
                  result: function result(e) {
                    t.push(e);
                  }
                }), Promise.all(t);
              },
              flush: function flush() {
                var t = [];
                return e.dispatch({
                  type: n,
                  result: function result(e) {
                    t.push(e);
                  }
                }), Promise.all(t);
              },
              pause: function pause() {
                e.dispatch({
                  type: i
                });
              },
              persist: function persist() {
                e.dispatch({
                  type: u,
                  register: d,
                  rehydrate: l
                });
              }
            });
          return y.persist(), y;
        }(e, r, f);
      }
    };
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});